/* tslint:disable */
/* eslint-disable */
/**
 * Micro Interactions B Service
 * API for micro-interactions
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
  ApiMicroInteractionPetAvatar,
  ApiMicroInteractionPetAvatarFromJSON,
  ApiMicroInteractionPetAvatarFromJSONTyped,
  ApiMicroInteractionPetAvatarToJSON,
} from './ApiMicroInteractionPetAvatar';
import {
  ApiPetAllergy,
  ApiPetAllergyFromJSON,
  ApiPetAllergyFromJSONTyped,
  ApiPetAllergyToJSON,
} from './ApiPetAllergy';
import {
  ApiPetBreed,
  ApiPetBreedFromJSON,
  ApiPetBreedFromJSONTyped,
  ApiPetBreedToJSON,
} from './ApiPetBreed';
import {
  ApiPetMedicalCondition,
  ApiPetMedicalConditionFromJSON,
  ApiPetMedicalConditionFromJSONTyped,
  ApiPetMedicalConditionToJSON,
} from './ApiPetMedicalCondition';
import {
  ApiPetMedication,
  ApiPetMedicationFromJSON,
  ApiPetMedicationFromJSONTyped,
  ApiPetMedicationToJSON,
} from './ApiPetMedication';
import {
  ApiPetMedicationAllergy,
  ApiPetMedicationAllergyFromJSON,
  ApiPetMedicationAllergyFromJSONTyped,
  ApiPetMedicationAllergyToJSON,
} from './ApiPetMedicationAllergy';
import {
  ApiPetType,
  ApiPetTypeFromJSON,
  ApiPetTypeFromJSONTyped,
  ApiPetTypeToJSON,
} from './ApiPetType';

/**
 * PetProfile Standard API Object
 * @export
 * @interface ApiMicroInteractionPet
 */
export interface ApiMicroInteractionPet {
  /**
   * System assigned. Not modifiable during creation or update.
   * @type {number}
   * @memberof ApiMicroInteractionPet
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof ApiMicroInteractionPet
   */
  name: string;
  /**
   *
   * @type {ApiPetType}
   * @memberof ApiMicroInteractionPet
   */
  type: ApiPetType;
  /**
   *
   * @type {string}
   * @memberof ApiMicroInteractionPet
   */
  gender: ApiMicroInteractionPetGenderEnum;
  /**
   * Returns up to 2 decimal for pet weight. Truncates to max of 2 decimals on create/update.
   * @type {number}
   * @memberof ApiMicroInteractionPet
   */
  weight: number | null;
  /**
   * Setting age will cause this value to be calculated during pet profile create/update
   * @type {Date}
   * @memberof ApiMicroInteractionPet
   */
  birthday: Date | null;
  /**
   * Current age in months.
   * @type {number}
   * @memberof ApiMicroInteractionPet
   */
  ageInMonths: number | null;
  /**
   * Current age in years.
   * @type {number}
   * @memberof ApiMicroInteractionPet
   */
  ageInYears: number | null;
  /**
   *
   * @type {Array<ApiPetBreed>}
   * @memberof ApiMicroInteractionPet
   */
  breeds: Array<ApiPetBreed>;
  /**
   *
   * @type {Array<ApiPetAllergy>}
   * @memberof ApiMicroInteractionPet
   */
  allergies: Array<ApiPetAllergy>;
  /**
   *
   * @type {Array<ApiPetMedication>}
   * @memberof ApiMicroInteractionPet
   */
  medications: Array<ApiPetMedication>;
  /**
   *
   * @type {Array<ApiPetMedicationAllergy>}
   * @memberof ApiMicroInteractionPet
   */
  medicationAllergies: Array<ApiPetMedicationAllergy>;
  /**
   *
   * @type {Array<ApiPetMedicalCondition>}
   * @memberof ApiMicroInteractionPet
   */
  medicalConditions: Array<ApiPetMedicalCondition>;
  /**
   *
   * @type {ApiMicroInteractionPetAvatar}
   * @memberof ApiMicroInteractionPet
   */
  avatar: ApiMicroInteractionPetAvatar;
  /**
   *
   * @type {string}
   * @memberof ApiMicroInteractionPet
   */
  size: ApiMicroInteractionPetSizeEnum;
}

/**
 * @export
 */
export const ApiMicroInteractionPetGenderEnum = {
  Unknown: 'UNKNOWN',
  Male: 'MALE',
  Female: 'FEMALE',
} as const;
export type ApiMicroInteractionPetGenderEnum = typeof ApiMicroInteractionPetGenderEnum[keyof typeof ApiMicroInteractionPetGenderEnum];

/**
 * @export
 */
export const ApiMicroInteractionPetSizeEnum = {
  Unknown: 'UNKNOWN',
  Xs: 'XS',
  Sm: 'SM',
  M: 'M',
  L: 'L',
  Xl: 'XL',
  G: 'G',
} as const;
export type ApiMicroInteractionPetSizeEnum = typeof ApiMicroInteractionPetSizeEnum[keyof typeof ApiMicroInteractionPetSizeEnum];

export function ApiMicroInteractionPetFromJSON(json: any): ApiMicroInteractionPet {
  return ApiMicroInteractionPetFromJSONTyped(json, false);
}

export function ApiMicroInteractionPetFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiMicroInteractionPet {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
    type: ApiPetTypeFromJSON(json['type']),
    gender: json['gender'],
    weight: json['weight'],
    birthday: json['birthday'] === null ? null : new Date(json['birthday']),
    ageInMonths: json['ageInMonths'],
    ageInYears: json['ageInYears'],
    breeds: (json['breeds'] as Array<any>).map(ApiPetBreedFromJSON),
    allergies: (json['allergies'] as Array<any>).map(ApiPetAllergyFromJSON),
    medications: (json['medications'] as Array<any>).map(ApiPetMedicationFromJSON),
    medicationAllergies: (json['medicationAllergies'] as Array<any>).map(
      ApiPetMedicationAllergyFromJSON,
    ),
    medicalConditions: (json['medicalConditions'] as Array<any>).map(
      ApiPetMedicalConditionFromJSON,
    ),
    avatar: ApiMicroInteractionPetAvatarFromJSON(json['avatar']),
    size: json['size'],
  };
}

export function ApiMicroInteractionPetToJSON(value?: ApiMicroInteractionPet | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    name: value.name,
    type: ApiPetTypeToJSON(value.type),
    gender: value.gender,
    weight: value.weight,
    birthday: value.birthday === null ? null : value.birthday.toISOString().substr(0, 10),
    ageInMonths: value.ageInMonths,
    ageInYears: value.ageInYears,
    breeds: (value.breeds as Array<any>).map(ApiPetBreedToJSON),
    allergies: (value.allergies as Array<any>).map(ApiPetAllergyToJSON),
    medications: (value.medications as Array<any>).map(ApiPetMedicationToJSON),
    medicationAllergies: (value.medicationAllergies as Array<any>).map(
      ApiPetMedicationAllergyToJSON,
    ),
    medicalConditions: (value.medicalConditions as Array<any>).map(ApiPetMedicalConditionToJSON),
    avatar: ApiMicroInteractionPetAvatarToJSON(value.avatar),
    size: value.size,
  };
}
